import mirrorCreator from 'mirror-creator';

////////////////// EDIT //////////////////

const actionTypes = mirrorCreator([
  'UPDATE_INPUT_FIELD',
  'CLOSE_INFO_BOX',
  'SET_SPINNER',
  'SUBMIT_BUTTON_ENABLED',
]);

export default actionTypes;
